import {
  Button,
  Checkbox,
  Form,
  Input,
  Modal,
  Select,
  Tooltip,
  Typography,
  Row,
  Grid,
  Col,
} from "antd";

import { useEffect, useRef, useState } from "react";
import { useMobxStores } from "../stores/stores";
import { observer } from "mobx-react";
import "./CreateLearningGraphModal.css";
import { useWatch } from "antd/es/form/Form";
import { LinkOutlined } from "@ant-design/icons";
import Icon from "@mdi/react";
import { mdiOpenInNew } from "@mdi/js";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import {
  DndContext,
  PointerSensor,
  useSensor,
  useSensors,
  closestCenter,
} from "@dnd-kit/core";
import {
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
  arrayMove,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { HolderOutlined } from "@ant-design/icons";
import {
  RightOutlined,
  LeftOutlined,
  DoubleRightOutlined,
  DoubleLeftOutlined,
  UpOutlined,
  DownOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";

const { useBreakpoint } = Grid;

function SortableItem2({ item }) {
  const { id, name, outcome } = item;
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    border: "1px solid #ccc",
    marginBottom: "4px",
    borderRadius: "4px",
    padding: "10px 14px",
    backgroundColor: "#ffffff",
    cursor: "grab",
    userSelect: "none",
    opacity: isDragging ? 0.7 : 1,
    boxShadow: isDragging ? "0 4px 10px rgba(0,0,0,0.15)" : "none",
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <div>
        <div style={{ fontWeight: 500 }}>{name}</div>
        <div style={{ fontSize: 12, opacity: 0.7 }}>{outcome}</div>
      </div>
    </div>
  );
}

function SortableItem3({ item, selected, onToggleSelect }) {
  const { id, name, outcome } = item;

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    border: "1px solid #ccc",
    marginBottom: "8px",
    borderRadius: "8px",
    padding: "10px 12px",
    backgroundColor: "#ffffff",
    cursor: "default",
    userSelect: "none",
    opacity: isDragging ? 0.7 : 1,
    boxShadow: isDragging ? "0 4px 10px rgba(0,0,0,0.15)" : "none",
    outline: selected ? "2px solid #2b57ff" : "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 10,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      onClick={() => onToggleSelect(id)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") onToggleSelect(id);
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
        <div style={{ fontWeight: 500 }}>{name}</div>
        <div style={{ fontSize: 12, opacity: 0.7 }}>{outcome}</div>
      </div>

      {/* Drag handle ONLY (prevents click conflicts) */}
      <div
        {...attributes}
        {...listeners}
        onClick={(e) => e.stopPropagation()} // don't toggle select when clicking handle
        style={{
          cursor: "grab",
          padding: "6px 8px",
          borderRadius: 6,
          border: "1px solid #e6e6e6",
          background: "#fafafa",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        title="Drag to reorder"
      >
        <HolderOutlined />
      </div>
    </div>
  );
}

function SortableItem({
  item,
  selected,
  onToggleSelect,
  order,
  cardClassName,
}) {
  const { id, name, outcome } = item;

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    border: "1px solid #ccc",
    marginBottom: "8px",
    borderRadius: "8px",
    padding: "10px 12px",
    backgroundColor: "#ffffff",
    cursor: "default",
    userSelect: "none",
    opacity: isDragging ? 0.7 : 1,
    boxShadow: isDragging ? "0 4px 10px rgba(0,0,0,0.15)" : "none",
    outline: selected ? "2px solid #2b57ff" : "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 10,
  };

  return (
    <div className="right-item-row">
      <div className="right-order-num">{order}</div>

      <div
        ref={setNodeRef}
        style={style}
        className={cardClassName}
        onClick={() => onToggleSelect(id)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") onToggleSelect(id);
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
          <div style={{ fontWeight: 500 }}>{name}</div>
          <div style={{ fontSize: 12, opacity: 0.7 }}>{outcome}</div>
        </div>

        {/* Drag handle ONLY */}
        <div
          {...attributes}
          {...listeners}
          onClick={(e) => e.stopPropagation()}
          style={{
            cursor: "grab",
            padding: "6px 8px",
            borderRadius: 6,
            border: "1px solid #e6e6e6",
            background: "#fafafa",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          title="Drag to reorder"
        >
          <HolderOutlined />
        </div>
      </div>
    </div>
  );
}
const levels = [
  { label: "Beginner", value: "beginner" },
  { label: "Intermediate", value: "intermediate" },
  { label: "Advanced", value: "advanced" },
  // { label: "Expert", value: "expert" },
];

const CreateLearningGraphModal = ({ isOpen, setIsOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const screens = useBreakpoint();

  const isMobile = !screens.sm;
  const [isVertical, setIsVertical] = useState(window.innerWidth < 900);

  const resetModalState = () => {
    form.resetFields();
    setItemsN([]);
    setSelectedOutcomes(new Set());
    setLeftQuery("");
    setMidQuery("");
    setMidSelectedIds(new Set());
    setRightSelectedIds(new Set());
  };
  useEffect(() => {
    const handleResize = () => {
      setIsVertical(window.innerWidth < 900);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const size = () => {
    let size;
    if (screens.xxl) size = "28px";
    else if (screens.xl) size = "20px";
    else if (screens.lg) size = "16px";
    else size = "16px";
    return size;
  };
  const { learningGraphStore } = useMobxStores();
  const [currentStep, setCurrentStep] = useState(0);
  const [form] = Form.useForm();

  const educationalOutcomes = useWatch("educationalOutcomes", form);
  const materialsByOutcome = useWatch("materialsByOutcome", form); // kept (not removed)
  const learningTopic = useWatch("learningTopic", form); // kept (not removed)
  const thematicField = useWatch("thematicField", form); // kept (not removed)
  const level = useWatch("level", form); // kept (not removed)

  const timeout = useRef(null);
  const [groupedMaterials, setGroupedMaterials] = useState([]);

  // RIGHT panel data (selected and ordered)
  const [itemsN, setItemsN] = useState([
    // { id: 1, name: "dfsfsdf", outcome: "fff" },
    // { id: 2, name: "eeeeee", outcome: "eee" },
  ]);

  // --- Three-panel selector state ---
  const [selectedOutcomes, setSelectedOutcomes] = useState(() => new Set());
  const [leftQuery, setLeftQuery] = useState("");
  const [midQuery, setMidQuery] = useState("");

  const [midSelectedIds, setMidSelectedIds] = useState(new Set());
  const [rightSelectedIds, setRightSelectedIds] = useState(new Set());

  const sensors = useSensors(useSensor(PointerSensor));

  const leftOutcomes =
    learningGraphStore.educationalOutcomes?.educational_outcomes || [];

  const filteredLeftOutcomes = leftOutcomes.filter((o) =>
    o.toLowerCase().includes((leftQuery || "").trim().toLowerCase()),
  );

  useEffect(() => {
    if (!isOpen) return;
    const fetchEducationalOutcomesAndMaterials = async () => {
      await learningGraphStore.GetEducationalOutcomesAndMaterials();
    };
    fetchEducationalOutcomesAndMaterials();
  }, [isOpen]);

  const items = [
    { key: "learningOutcomes", title: "Learning outcomes" },
    { key: "learningMaterials", title: "Learning materials" },
    { key: "fields", title: "Details" },
  ];

  const handleSearch = async (inputValue) => {
    if (inputValue !== "") {
      await learningGraphStore.GetFilteredEducationalOutcome(inputValue);
    } else {
      await learningGraphStore.GetEducationalOutcome();
    }
  };

  const debouncedSearch = (inputValue) => {
    if (timeout.current) clearTimeout(timeout.current);
    timeout.current = setTimeout(() => handleSearch(inputValue), 300);
  };

  // Flatten all materials from groupedMaterials
  const allMaterials = groupedMaterials.flatMap((g) => g.results || []);

  // Left list outcomes: selected outcomes from the checkbox group
  // const leftOutcomes = (educationalOutcomes || []).filter(Boolean);

  useEffect(() => {
    // optional: if outcomes list changes, drop selections that no longer exist
    setSelectedOutcomes((prev) => {
      const next = new Set([...prev].filter((o) => leftOutcomes.includes(o)));
      return next;
    });
    setMidSelectedIds(new Set());
  }, [leftOutcomes.join("|")]);

  // const filteredLeftOutcomes = leftOutcomes.filter((o) =>
  //   o.toLowerCase().includes((leftQuery || "").trim().toLowerCase())
  // );

  const visibleMiddleMaterials = learningGraphStore.materials
    .filter((m) => selectedOutcomes.has(m.educational_outcome))
    .filter((m) =>
      (midQuery || "").trim()
        ? (m.title || "").toLowerCase().includes(midQuery.trim().toLowerCase())
        : true,
    );

  const isInRight = (id) => itemsN.some((x) => x.id === id);

  const toggleMidSelected = (id) => {
    setMidSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };
  const toggleOutcome = (title) => {
    setSelectedOutcomes((prev) => {
      const next = new Set(prev);
      if (next.has(title)) next.delete(title);
      else next.add(title);
      return next;
    });
    setMidSelectedIds(new Set()); // optional: clear selected materials when outcome set changes
  };

  const toggleRightSelected = (id) => {
    setRightSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  const addSelectedFromMiddle = () => {
    if (!midSelectedIds.size) return;

    setItemsN((prev) => {
      const next = [...prev];
      for (const id of midSelectedIds) {
        if (next.some((x) => x.id === id)) continue;
        const m = visibleMiddleMaterials.find((x) => x.id === id);
        if (!m) continue;
        next.push({ id: m.id, name: m.title, outcome: m.educational_outcome });
      }
      return next;
    });

    setMidSelectedIds(new Set());
  };

  const addAllVisibleFromMiddle = () => {
    if (!visibleMiddleMaterials.length) return;

    setItemsN((prev) => {
      const next = [...prev];
      for (const m of visibleMiddleMaterials) {
        if (next.some((x) => x.id === m.id)) continue;
        next.push({ id: m.id, name: m.title, outcome: m.educational_outcome });
      }
      return next;
    });

    setMidSelectedIds(new Set());
  };

  const removeSelectedFromRight = () => {
    if (!rightSelectedIds.size) return;
    setItemsN((prev) => prev.filter((x) => !rightSelectedIds.has(x.id)));
    setRightSelectedIds(new Set());
  };

  const removeAllFromRight = () => {
    setItemsN([]);
    setRightSelectedIds(new Set());
  };

  const handleSubmit = async () => {
    if (!canSubmit) return;

    const ids = itemsN.map((mat) => mat.id);

    const newData = {
      learning_topic: form.getFieldValue("learningTopic"),
      thematic_field: form.getFieldValue("thematicField"),
      learning_material_ids: ids,
      level: form.getFieldValue("level"),
    };

    // console.log(newData);
    learningGraphStore.PostLearningGraph(newData);

    // setIsOpen(false);
    // form.resetFields();
    // return;

    setIsOpen(false);
    resetModalState();
    return;
  };

  const canSubmit =
    !!(learningTopic && learningTopic.trim()) &&
    !!(thematicField && thematicField.trim()) &&
    !!level &&
    itemsN.length > 0;

  const canAddSelected = midSelectedIds.size > 0;

  // add all only if there exists at least one visible item NOT already in right
  const canAddAll = visibleMiddleMaterials.some((m) => !isInRight(m.id));

  const canRemoveSelected = rightSelectedIds.size > 0;
  const canRemoveAll = itemsN.length > 0;

  const DoubleDown = () => (
    <span
      style={{ display: "flex", flexDirection: "column", lineHeight: "10px" }}
    >
      <DownOutlined style={{ fontSize: 10 }} />
      <DownOutlined style={{ fontSize: 10, marginTop: -4 }} />
    </span>
  );

  const DoubleUp = () => (
    <span
      style={{ display: "flex", flexDirection: "column", lineHeight: "10px" }}
    >
      <UpOutlined style={{ fontSize: 10 }} />
      <UpOutlined style={{ fontSize: 10, marginTop: -4 }} />
    </span>
  );

  return (
    <Modal
      title="Create Learning Path"
      className="create-learning-graph-modal"
      open={isOpen}
      destroyOnClose
      // onCancel={() => {
      //   setIsOpen(false);
      //   form.resetFields();
      // }}
      onCancel={() => {
        setIsOpen(false);
        resetModalState();
      }}
      footer={[
        <Button
          disabled={!canSubmit}
          type="primary"
          key="button-next"
          onClick={handleSubmit}
        >
          Submit
        </Button>,
      ]}
      width="90%"
    >
      <Form
        form={form}
        layout="vertical"
        className="create-learning-graph-form"
      >
        <>
          {/* <Row>
            <Form.Item
              style={{ width: "30%", marginRight: "5%" }}
              label="Learning Topic"
              name="learningTopic"
              rules={[{ required: true }]}
            >
              <Input placeholder="Learning topic" />
            </Form.Item>

            <Form.Item
              style={{ width: "30%", marginRight: "5%" }}
              label="Thematic Field"
              name="thematicField"
              rules={[{ required: true }]}
            >
              <Input placeholder="Thematic field" />
            </Form.Item>

            <Form.Item
              style={{ width: "30%" }}
              label="Level"
              name="level"
              rules={[{ required: true }]}
            >
              <Select placeholder="Level">
                {levels.map((lvl, index) => (
                  <Select.Option key={index} value={lvl.value}>
                    {lvl.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Row> */}

          <Row gutter={16}>
            <Col span={isVertical ? 24 : 7}>
              <Form.Item
                label="Learning Topic"
                name="learningTopic"
                rules={[{ required: true }]}
              >
                <Input placeholder="Learning topic" maxLength={100} showCount />
              </Form.Item>
            </Col>

            <Col span={isVertical ? 24 : 7}>
              <Form.Item
                label="Thematic Field"
                name="thematicField"
                rules={[{ required: true }]}
              >
                <Input placeholder="Thematic field" maxLength={100} showCount />
              </Form.Item>
            </Col>

            <Col span={isVertical ? 24 : 7}>
              <Form.Item
                label={
                  <span>
                    Level&nbsp;
                    <Tooltip
                      title={
                        <div>
                          <div>Beginner → Understand / Apply</div>
                          <div>Intermediate → Analyze</div>
                          <div>Advanced → Evaluate / Create</div>
                        </div>
                      }
                    >
                      <InfoCircleOutlined style={{ fontSize: "14px" }} />
                    </Tooltip>
                  </span>
                }
                name="level"
                rules={[{ required: true }]}
              >
                <Select placeholder="Level">
                  {levels.map((lvl, index) => (
                    <Select.Option key={index} value={lvl.value}>
                      {lvl.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Typography>
            To design your learning path, select the target learning outcomes
            and learning materials, then arrange the selected materials in the
            desired order.
          </Typography>
        </>

        <>
          {/* New 3-panel selector UI */}
          <div className="three-panel-wrap">
            {/* LEFT */}
            <div className="three-panel">
              <h3>Learning outcomes</h3>
              <div
                style={{
                  display: "flex",
                  justifyContent: "start",
                }}
              >
                <span>
                  <Typography style={{ fontSize: "12px", color: "#c92ad5" }}>
                    Can't find the outcome you need?
                  </Typography>
                </span>
                <span>
                  <Tooltip title="If you already have learning materials aligned with your desired outcomes, head to the Content Catalogue to upload or update them. Once added, the list of learning outcomes will automatically include yours.">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        fontSize: "14px",
                        color: "#c92ad5",
                      }}
                    />
                  </Tooltip>
                </span>
              </div>

              <div className="three-row">
                <input
                  className="three-search"
                  type="search"
                  placeholder="search outcomes..."
                  value={leftQuery}
                  onChange={(e) => setLeftQuery(e.target.value)}
                />
              </div>

              <div className="three-scroll">
                {/* {learningGraphStore.educationalOutcomes?.educational_outcomes */}
                {filteredLeftOutcomes.length === 0 ? (
                  // ?.length === 0 ? (
                  <div style={{ opacity: 0.6, padding: 8 }}>
                    No outcomes to show.
                  </div>
                ) : (
                  // learningGraphStore.educationalOutcomes?.educational_outcomes?.map(
                  //   (title) => (
                  filteredLeftOutcomes.map((title) => (
                    <div
                      key={title}
                      className={
                        "three-item" +
                        (selectedOutcomes.has(title) ? " active" : "")
                      }
                      onClick={() => toggleOutcome(title)}
                    >
                      {title}
                    </div>
                  ))
                )}
              </div>
            </div>

            {/* MIDDLE */}
            <div className="three-panel">
              <h3>Learning materials</h3>

              {/* <div className="three-row">
                <input
                  className="three-search"
                  type="search"
                  placeholder="search materials..."
                  value={midQuery}
                  onChange={(e) => {
                    setMidQuery(e.target.value);
                    setMidSelectedIds(new Set());
                  }}
                />
              </div> */}

              <div className="three-scroll">
                {visibleMiddleMaterials.length === 0 ? (
                  <div style={{ opacity: 0.6, padding: 8 }}>
                    {selectedOutcomes.size
                      ? "No materials for the selected outcomes."
                      : "Select one or more outcomes."}
                  </div>
                ) : (
                  visibleMiddleMaterials.map((m) => {
                    const selected = midSelectedIds.has(m.id);
                    const alreadyAdded = isInRight(m.id);

                    return (
                      <div
                        key={m.id}
                        className={"three-item" + (selected ? " selected" : "")}
                        onClick={() => toggleMidSelected(m.id)}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          {" "}
                          <strong>{m.title}</strong>{" "}
                          <Icon
                            path={mdiOpenInNew}
                            // size={mdiIconSize()}
                            style={{
                              // fontSize: size(),
                              width: size(),
                              height: size(),
                              color: "#D01FDF",
                              cursor: "pointer",
                              marginRight: "6px",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              window.open(`/catalogue/${m.id}`, "_blank");
                            }}
                            // onClick={(e) => {
                            //   e.stopPropagation();
                            //   navigate(`/catalogue/${m.id}`, {
                            //     state: { backgroundLocation: location },
                            //   });
                            // }}
                          />
                        </div>

                        <span className="three-meta">
                          Learning outcome: {m.educational_outcome}
                          {alreadyAdded ? " • already added" : ""}
                        </span>
                      </div>
                    );
                  })
                )}
              </div>
            </div>

            {/* BUTTONS */}
            {/* <div className="three-controls">
              <button
                className="three-circle"
                title="Add selected (>)"
                onClick={addSelectedFromMiddle}
                disabled={midSelectedIds.size === 0}
                type="button"
              >
                ›
              </button>

              <button
                className="three-circle"
                title="Add all visible (>>)"
                onClick={addAllVisibleFromMiddle}
                disabled={visibleMiddleMaterials.length === 0}
                type="button"
              >
                »
              </button>

              <button
                className="three-circle"
                title="Remove selected (<)"
                onClick={removeSelectedFromRight}
                disabled={rightSelectedIds.size === 0}
                type="button"
              >
                ‹
              </button>

              <button
                className="three-circle"
                title="Remove all (<<)"
                onClick={removeAllFromRight}
                disabled={itemsN.length === 0}
                type="button"
              >
                «
              </button>



            </div> */}

            {/* BUTTONS */}
            <div className={"three-controls" + (isVertical ? " vertical" : "")}>
              {/* <Button
                shape="circle"
                type="primary"
                icon={isVertical ? <DownOutlined /> : <RightOutlined />}
                onClick={addSelectedFromMiddle}
                disabled={midSelectedIds.size === 0}
                style={{
                  background: "#0b2a6f",
                  borderColor: "#0b2a6f",
                  color: "#fff",
                }}
              />

              <Button
                shape="circle"
                type="primary"
                icon={isVertical ? <DownOutlined /> : <DoubleRightOutlined />}
                onClick={addAllVisibleFromMiddle}
                disabled={visibleMiddleMaterials.length === 0}
                style={{
                  background: "#0b2a6f",
                  borderColor: "#0b2a6f",
                  color: "#fff",
                }}
              />

              <Button
                shape="circle"
                type="primary"
                icon={isVertical ? <UpOutlined /> : <LeftOutlined />}
                onClick={removeSelectedFromRight}
                disabled={rightSelectedIds.size === 0}
                style={{
                  background: "#bfc5d2", // keep your “disabled-ish” grey look
                  borderColor: "#bfc5d2",
                  color: "#fff",
                }}
              />

              <Button
                shape="circle"
                type="primary"
                icon={isVertical ? <UpOutlined /> : <DoubleLeftOutlined />}
                onClick={removeAllFromRight}
                disabled={itemsN.length === 0}
                style={{
                  background: "#bfc5d2",
                  borderColor: "#bfc5d2",
                  color: "#fff",
                }}
              /> */}

              <Button
                shape="circle"
                type="primary"
                icon={isVertical ? <DownOutlined /> : <RightOutlined />}
                onClick={addSelectedFromMiddle}
                disabled={!canAddSelected}
                className="transfer-btn"
              />

              <Button
                shape="circle"
                type="primary"
                icon={isVertical ? <DoubleDown /> : <DoubleRightOutlined />}
                onClick={addAllVisibleFromMiddle}
                disabled={!canAddAll}
                className="transfer-btn"
              />

              <Button
                shape="circle"
                type="primary"
                icon={isVertical ? <UpOutlined /> : <LeftOutlined />}
                onClick={removeSelectedFromRight}
                disabled={!canRemoveSelected}
                className="transfer-btn"
              />

              <Button
                shape="circle"
                type="primary"
                icon={isVertical ? <DoubleUp /> : <DoubleLeftOutlined />}
                onClick={removeAllFromRight}
                disabled={!canRemoveAll}
                className="transfer-btn"
              />
            </div>

            {/* RIGHT */}

            <div className="three-panel">
              <h3>Selected and ordered Learning materials</h3>
              <div className="three-scroll">
                {itemsN.length === 0 ? (
                  <div style={{ opacity: 0.6, padding: 8 }}>
                    No selected materials yet.
                  </div>
                ) : (
                  <DndContext
                    sensors={sensors}
                    collisionDetection={closestCenter}
                    onDragEnd={(event) => {
                      const { active, over } = event;
                      if (!over || active.id === over.id) return;

                      setItemsN((prev) => {
                        const oldIndex = prev.findIndex(
                          (i) => i.id === active.id,
                        );
                        const newIndex = prev.findIndex(
                          (i) => i.id === over.id,
                        );
                        return arrayMove(prev, oldIndex, newIndex);
                      });
                    }}
                  >
                    <SortableContext
                      items={itemsN.map((i) => i.id)}
                      strategy={verticalListSortingStrategy}
                    >
                      <div>
                        {/* {itemsN.map((item) => (
                          <SortableItem
                            key={item.id}
                            item={item}
                            selected={rightSelectedIds.has(item.id)}
                            onToggleSelect={(id) => {
                              setRightSelectedIds((prev) => {
                                const next = new Set(prev);
                                if (next.has(id)) next.delete(id);
                                else next.add(id);
                                return next;
                              });
                            }}
                          />
                        ))} */}

                        {itemsN.map((item, idx) => (
                          <SortableItem
                            key={item.id}
                            item={item}
                            order={idx + 1} // ✅ 1..N
                            cardClassName="right-item-card" // ✅ fixed width
                            selected={rightSelectedIds.has(item.id)}
                            onToggleSelect={(id) => {
                              setRightSelectedIds((prev) => {
                                const next = new Set(prev);
                                if (next.has(id)) next.delete(id);
                                else next.add(id);
                                return next;
                              });
                            }}
                          />
                        ))}
                      </div>
                    </SortableContext>
                  </DndContext>
                )}
              </div>
            </div>
          </div>
        </>
      </Form>
    </Modal>
  );
};

export default observer(CreateLearningGraphModal);
